angular.module('cfn').directive('cfnEditHarvesttypes', [
  '$rootScope',
  function($rootScope) {
    return {
      restrict: 'E',
      scope: {
        item: '=',
        harvestUnit: '='
      },
      templateUrl: require('./cfn-edit-harvesttypes.tpl.html'),
      link: function(scope, element, attrs) {
        scope.$rootScope = $rootScope;
      },
      controller: [
        '$scope',
        'unitConverter',
        'userSettingsService',
        function($scope, unitConverter, userSettingsService) {
          var defaultUnit = 'MASSPERMASS_KGPERDT';

          /*
             *	This $scope.nutrientUnitFn Function composes the enum String for displaying the correct
             * and properly converted nutrientUnit (Nährstoffentzug).
             *
             * E.g. if harveststockyarddisplayunit is tons (t):
             *      1. the unit to be displayed is MASSPERMASS_KGPERT instead of MASSPERMASS_KGPERDT, which is the default
             *      2. the value also needs to be converted through the convertUnit filter (that's done in the html template)
             *
             * It's used by the cfn-edit-harvesttypes directive.
             */
          $scope.userNutrientUnit = (function() {
            var ratioUnit = unitConverter.splitRatio(
              $scope.item.sysHarvestType.nutrientValueUnit
            );

            if (unitConverter.isMass(ratioUnit.denominator)) {
              if (unitConverter.isUnitQuantity($scope.harvestUnit)) {
                //if it's a unit of type quantity (e.g.QUANTITY_PIECE) return the default value MASSPERMASS_KGPERDT.
                return defaultUnit;
              } else {
                //convert from selected mass harvest unit
                return unitConverter.joinRatio(
                  ratioUnit.numerator,
                  $scope.harvestUnit
                );
              }
            } else if (unitConverter.isArea(ratioUnit.denominator)) {
              //area unit, will be converted from user preferences
              return unitConverter.joinRatio(
                ratioUnit.numerator,
                userSettingsService.getAreaUnitEnum()
              );
            } else {
              //in any other case, just pass it through.
              return $scope.item.sysHarvestType.nutrientValueUnit;
            }
          })();

          /*
             * Same concept but just for humus.
             */
          $scope.userHumusUnit = (function() {
            var ratioUnit = unitConverter.splitRatio(
              $scope.item.sysHarvestType.humusValueUnit
            );
            return unitConverter.joinRatio(
              ratioUnit.numerator,
              userSettingsService.getAreaUnitEnum()
            );
          })();
        }
      ]
    };
  }
]);

angular.module('cfn').directive('cfnEditSysPlantProtectantUsecase', [
  '$rootScope',
  '$log',
  function($rootScope, $log) {
    return {
      restrict: 'E',
      scope: {
        item: '=',
        skipType: '@'
      },
      templateUrl: require('./cfn-edit-sysplant-protectant-usecase.tpl.html'),
      link: function(scope, element, attrs) {
        scope.$rootScope = $rootScope;
      }
    };
  }
]);

angular.module('cfn').directive('cfnEditSysplantprotectantrestriction', [
  '$rootScope',
  '$log',
  function($rootScope, $log) {
    return {
      restrict: 'E',
      scope: {
        item: '=',
        skipType: '@'
      },
      templateUrl: require('./cfn-edit-sysplant-protectant-restriction.tpl.html'),
      link: function(scope, element, attrs) {
        scope.$rootScope = $rootScope;
      }
    };
  }
]);
